import { createStore } from 'redux'
import * as R from 'ramda'
import {
  INIT_USER,
  SET_MESSAGE,
  UPDATE_BOOKING,
  CLEAR_BOOKING,
  SET_LOADING,
  UPDATE_REDEEM,
  SET_CATEGORY,
  SET_GROUP,
} from './action'

const initialState = {
  message: '',
  initStatus: false,
  user: {
    session: '',
    uid: '',
    key: '',
    serverTime: '',
    ts: '',
    tokenExpire: '',
    profileId: '',
  },
  category: [],
  booking: {},
  redeem: {},
  isLoading: true,
  loaderType: 'initializing',
}

const reducer = (state = initialState, payload) => {
  switch (payload.type) {
    case INIT_USER:
      // alert('init user')
      return {
        ...state,
        initStatus: true,
        user: {
          ...state.user,
          ...payload.user,
          ts: Date.now(),
        },
      }
    case SET_MESSAGE:
      return {
        ...state,
        message: payload.message,
      }
    case UPDATE_BOOKING:
      return {
        ...state,
        booking: R.mergeDeepRight(state.booking, payload.booking),
      }
    case CLEAR_BOOKING:
      return {
        ...state,
        booking: {},
      }
    case UPDATE_REDEEM:
      return {
        ...state,
        redeem: {
          ...state.redeem,
          ...payload.redeem,
        },
      }
    case SET_LOADING:
      return {
        ...state,
        isLoading: payload.isLoading,
        loaderType: payload.loaderType,
      }
    case SET_CATEGORY:
      return {
        ...state,
        category: payload.category,
      }
    case SET_GROUP:
      return {
        ...state,
        group: payload.group,
      }
    default:
      return state
  }
}

const gg = {}

export const getGG = () => gg

export default preloadedState => {
  const store = createStore(reducer, preloadedState)
  gg.store = store
  return store
}
